/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    if (document.querySelector('.template-cart')) {
        document.querySelectorAll('.cart__item__remove').forEach(function (item) {
            item.addEventListener('click', function (){
                setTimeout(function (){
                    location.reload();
                },1000)
            })
        })
    }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
